import React, { useEffect, useState } from "react";
import signinLogo from "../../assets/images/login/signin-logo.png";
import { Link, useNavigate, NavLink } from "react-router-dom";
import { useFormik } from "formik";
import { object, string } from "yup";
import { axiosInstance } from "../../axiosInstance";
import "./Forgot.css";

let loginSchema = object({
  mobile_no: string().required("Mobile number is required"),
});

export function Forgot() {
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState("");
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      mobile_no: "",
      user_type: "agent",
    },
    validationSchema: loginSchema,
    validateOnBlur: true,
    onSubmit: async (values) => {
      setIsLoading(true);
      setServerError("");

      const payload = {
        mobile_no: values.mobile_no.trim(),
        user_type: "agent",
      };

      console.log("👉 Payload before sending to API:", payload);

      try {
        const response = await axiosInstance.post(`/forgot-password/`, payload);
        console.log("Response from API:", response);

        if (response.data.status === "success") {
          const token = response.data.data.token;
          localStorage.setItem("otp_token", token);
          localStorage.setItem("mobile_no", values.mobile_no);
          navigate("/otp-forgot-password");
        } else {
          setServerError(response.data.message || "failed");
        }
      } catch (error) {
        setServerError(
          error.response?.data?.message ||
            "Something went wrong. Please try again."
        );
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <div className="signin-container">
      <div className="signin-left">
        <div>
          <div className="signin-logo">
            <img src={signinLogo} />
          </div>
          <div className="signin-lefttext">
            Welcome to Go Mak Referral — your platform to manage medicine
            deliveries with speed, security, and reliability. Together, we
            ensure healthcare providers get the medicines they need, on time.
          </div>
        </div>
      </div>
      <div className="signin-right">
        <div>
          <form className="signin-formContainer" onSubmit={formik.handleSubmit}>
            <div className="signin-title">Password Reset</div>
            {/* <div className="signin-subtitle">Password Reset</div> */}
            <div className="signin-field">
              <label>
                <span className="text-danger">*</span>Mobile Number
              </label>
              <div>
                <input
                  type="tel"
                  placeholder="Enter mobile number"
                  maxLength={10}
                  pattern="[0-9]*"
                  inputMode="numeric"
                  name="mobile_no"
                  value={formik.values.mobile_no}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.mobile_no && formik.errors.mobile_no
                      ? "input-error-signIn"
                      : ""
                  }
                />
                {formik.touched.mobile_no && formik.errors.mobile_no && (
                  <div className="error-message-signIn">
                    {formik.errors.mobile_no}
                  </div>
                )}
              </div>
            </div>

            {serverError && (
              <div className="server-error-message">{serverError}</div>
            )}
            <div className="btnLogin" style={{ marginTop: "0px" }}>
              <button type="submit" disabled={isLoading}>
                {isLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
            <div className="btnBack">
              <Link to="/">
                <button>Back</button>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
